import axios from '../axiosCall'
import Urls from "../endpoints";


export const GetHistoryOfImportantEntities = (requestId) => {
    return axios.post(`${Urls.GetHistoryOfImportantEntities()}?requestId=${requestId}`, [])
}

export const GetEntitiesEnum = () => {
    return axios.post(Urls.GetEntitiesEnum())
}

export const GetAdminUsers = () => {
    return axios.post(Urls.GetAdminUsers())
}

export const GetRequestLogOfImportantAPIs = ({ query, body }) => {
    return axios.post(Urls.GetRequestLogOfImportantAPIs() + query)
}             